// Product funnel events. Each one goes to users/{uid}/events (create-only for the browser, read by
// the Monday report and the growth session) and, when GA4 is loaded, to GA4 as well.
// Fire-and-forget: tracking never throws and never blocks the UI.
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';

const NAME_RE = /^[a-z][a-z0-9_]{0,39}$/;
const MAX_PROPS = 12;

// Keeps only short scalar values, so the rules' size checks always pass
export function cleanProps(props) {
  const out = {};
  Object.entries(props || {}).slice(0, MAX_PROPS).forEach(([key, value]) => {
    if (!/^[a-zA-Z][a-zA-Z0-9_]{0,39}$/.test(key)) return;
    if (typeof value === 'string') out[key] = value.slice(0, 100);
    else if (typeof value === 'number' && Number.isFinite(value)) out[key] = value;
    else if (typeof value === 'boolean') out[key] = value;
  });
  return out;
}

export function track(name, props) {
  try {
    if (!NAME_RE.test(name)) return;
    const clean = cleanProps(props);
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag('event', name, clean);
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    addDoc(collection(db, 'users', uid, 'events'), {
      name,
      props: clean,
      path: (window.location?.pathname || '').slice(0, 200),
      at: serverTimestamp(),
    }).catch(() => {});
  } catch {
    // never let analytics break the app
  }
}
